var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4918 17.5927L18.8818 20.7527C18.9818 21.5827 18.0918 22.1627 17.3818 21.7327L13.1918 19.2427C12.7318 19.2427 12.2818 19.2127 11.8418 19.1527C12.5818 18.2827 13.0218 17.1827 13.0218 15.9927C13.0218 13.1527 10.5618 10.8527 7.52182 10.8527C6.36182 10.8527 5.29183 11.1827 4.40182 11.7627C4.37182 11.5127 4.36182 11.2627 4.36182 11.0027C4.36182 6.45269 8.31182 2.7627 13.1918 2.7627C18.0718 2.7627 22.0218 6.45269 22.0218 11.0027C22.0218 13.7027 20.6318 16.0927 18.4918 17.5927Z",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0234 15.9927C13.0234 17.1827 12.5834 18.2828 11.8434 19.1528C10.8534 20.3528 9.28344 21.1227 7.52344 21.1227L4.91344 22.6727C4.47344 22.9427 3.91343 22.5727 3.97343 22.0627L4.22343 20.0928C2.88343 19.1628 2.02344 17.6727 2.02344 15.9927C2.02344 14.2327 2.96344 12.6828 4.40344 11.7628C5.29344 11.1828 6.36344 10.8528 7.52344 10.8528C10.5634 10.8528 13.0234 13.1527 13.0234 15.9927Z",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.2ca93062.svg";
export { ForwardRef as ReactComponent };